import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useFujiAuth } from './useFujiAuth';

/**
 * ログインが必要な場合はこのコンポーネントを挟む。
 */
export const RequireAuth: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { isAuthenticated } = useFujiAuth();
    const location = useLocation();
    //ログインしていない
    if (!isAuthenticated) {
        return <Navigate to={'/buy'} replace state={{ path: location.pathname }} />;
    }
    if (children != null) {
        return children;
    }
    return <Outlet />;
};
